import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjetoTramitacaoService } from '../services/projeto-tramitacao.service';

@Injectable({
  providedIn: 'root',
})
export class ProjetoTramitacaoResolver implements Resolve<boolean> {
  constructor(private service: ProjetoTramitacaoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.parent.params.id);
  }
}
